import { useEffect, useRef, useState } from "react";

/**
 * Width of an element in px, kept current as it resizes, so an SVG can be drawn
 * at its real size (crisp text, no stretched viewBox). Returns [ref, width];
 * width is 0 until the element has been measured.
 */
export function useElementWidth() {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    setWidth(el.getBoundingClientRect().width);
    if (typeof ResizeObserver === "undefined") return undefined;
    const ro = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return [ref, width];
}
